module.exports = __webpack_public_path__ + "img/bg_function04_2_d.2beeacbd.png";